import { requestUrl } from "@/http/requestUrl";
import axios from 'axios';
const instance = axios.create();
export async function getBotInfo(callBack){
    let url = requestUrl.knowledge.getBotBindInfo + "?userId=" + localStorage.getItem("_uid");
    await instance.get(url).then(res => {
        if (res.data.code === "0"){
            let resData = res.data.data;
            sessionStorage.setItem('_agentId',resData.agentId);
            sessionStorage.setItem('_corpId',resData.corpId);
            sessionStorage.setItem('_bindCode',resData.bindCode);
            sessionStorage.setItem('_apiKey',resData.apiKey);
            sessionStorage.setItem('_wechatType',resData.type);
            sessionStorage.setItem('_userId',resData.userId || resData.openId);
            sessionStorage.setItem('_userMemberId',resData.userMemberId);
            sessionStorage.setItem('_srcUserId',resData.memberUserId)
            sessionStorage.setItem(
                "_userDeptId",
                resData.userDeptId
            );
            sessionStorage.setItem(
                "_userDeptName",
                resData.userDeptName
            );
            sessionStorage.setItem('_sourceId',resData.sourceId);
            sessionStorage.setItem('_secret',resData.secret);
            localStorage.setItem('haveWorkOrder',resData.haveWorkOrder);
            if (resData.passedAgents && resData.passedAgents.length > 0){
                sessionStorage.setItem('passedAgents',JSON.stringify(resData.passedAgents))
            } else {
                sessionStorage.setItem('passedAgents',JSON.stringify([]))
            }
            if (resData.memberInDepartDto){
                localStorage.setItem('memberInDepartDto', JSON.stringify(resData.memberInDepartDto) || '[]');
                sessionStorage.setItem('memberInDepartDto', JSON.stringify(resData.memberInDepartDto) || '[]')
            }
            if (callBack){
                callBack(resData);
            }
        }
    }).catch(() => {
        if (callBack){
            callBack();
        }
    })
}